import React from 'react'
import { connect } from 'react-redux'
import ReactGA from 'react-ga';
import { doLogoutThunk } from '../actions/auth'
import { withRouter } from 'react-router-dom';

class LogoutButton extends React.Component {

    doLogout = () => {
        ReactGA.pageview('/logout');
        this.props.dispatch(doLogoutThunk())
            .then(() => {
                console.log("Successful logout");
            })
            .catch(err => {
                console.log("Unsuccessful logout");
                this.props.history.push("/");
            });;
    }

    render() {
        return (
            <div className="container">
                <button className="btn btn-primary" onClick={this.doLogout}>{this.props.strings.LOGOUT_BUTTON_TITLE}</button>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
    }
};

const ConnectedLogoutButton = connect(
    mapStateToProps,
)(LogoutButton);
export default withRouter(ConnectedLogoutButton);
